import React from 'react';
import 'iconify-icon';

const ROLE_STYLES = {
  Franqueado: 'bg-accent-orange text-white',
  Trainer: 'bg-[#EAEAEA] text-black border border-[#EAEAEA]',
  Comercial: 'bg-[#555555] text-white',
};

export const FranchiseTeam = ({ team }) => {
  if (!team?.length) return null;
  return (
    <section
      className="relative py-20 border-b border-neutral-900"
      style={{ background: 'rgba(10, 10, 10, 0.78)' }}
      data-testid="franchise-team-section"
    >
      <div className="relative z-10 max-w-6xl mx-auto px-6 md:px-12">
        <div className="text-center mb-12">
          <span className="text-[10px] font-mono uppercase tracking-[0.3em] text-accent-orange mb-3 block">
            Nossa equipe local
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-[#EAEAEA]">
            {team.length} profissiona{team.length > 1 ? 'is' : 'l'} ativo
            {team.length > 1 ? 's' : ''}
          </h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {team.map((m, i) => {
            const roles = Array.isArray(m.roles) && m.roles.length
              ? m.roles
              : (m.role ? [m.role] : []);
            const igHandle = m.instagram ? m.instagram.replace('@', '') : null;
            return (
              <article
                key={`${m.name}-${i}`}
                data-testid={`franchise-trainer-${i}`}
                className="bg-[#0F0F0F] border border-[#333333] rounded-2xl p-6 text-center hover:border-accent-orange transition-colors"
              >
                {m.photo ? (
                  <img
                    src={m.photo}
                    alt={m.name}
                    className="w-24 h-24 rounded-full object-cover mx-auto mb-4 ring-2 ring-[#333333]"
                  />
                ) : (
                  <div className="w-24 h-24 rounded-full bg-[#1F1F1F] border border-[#333333] flex items-center justify-center mx-auto mb-4 text-accent-orange">
                    <iconify-icon icon="solar:user-circle-linear" className="text-5xl"></iconify-icon>
                  </div>
                )}

                <h3 className="font-bold text-lg text-[#EAEAEA] mb-2">{m.name}</h3>

                {m.corporate_role && (
                  <p
                    className="text-[10px] font-mono uppercase tracking-widest text-accent-orange mb-2"
                    data-testid="franchise-trainer-corporate-role"
                  >
                    {m.corporate_role}
                  </p>
                )}

                {roles.length > 0 && (
                  <div className="flex flex-wrap justify-center gap-1.5 mb-3">
                    {roles.map((r) => (
                      <span
                        key={`${m.name}-${r}`}
                        data-testid={`team-badge-${r.toLowerCase()}`}
                        className={`px-2.5 py-0.5 rounded-full text-[10px] font-mono uppercase tracking-wider ${
                          ROLE_STYLES[r] || 'bg-neutral-700 text-white'
                        }`}
                      >
                        {r}
                      </span>
                    ))}
                  </div>
                )}

                {(m.city || m.state) && (
                  <p className="text-[11px] text-neutral-600 mb-3">
                    {m.city}
                    {m.state && ` · ${m.state}`}
                  </p>
                )}

                {igHandle && (
                  <a
                    href={`https://instagram.com/${igHandle}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-1.5 text-xs text-neutral-400 hover:text-accent-orange transition-colors"
                  >
                    <iconify-icon icon="mdi:instagram"></iconify-icon>
                    {m.instagram}
                  </a>
                )}
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};
